import React, { useEffect, useState } from "react";

const DISMISS_STORAGE_KEY = "logistiq.pwa.installDismissed";

const PwaPrompts = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [updateRegistration, setUpdateRegistration] = useState(null);

  useEffect(() => {
    const dismissed = window.localStorage.getItem(DISMISS_STORAGE_KEY);

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      if (!dismissed) setShowInstall(true);
    };

    const onAppInstalled = () => {
      setShowInstall(false);
      setDeferredPrompt(null);
    };

    const onSwUpdate = (e) => {
      setUpdateRegistration(e.detail);
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onAppInstalled);
    window.addEventListener("logistiq:sw-update", onSwUpdate);

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onAppInstalled);
      window.removeEventListener("logistiq:sw-update", onSwUpdate);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice.catch(() => {});
    setDeferredPrompt(null);
    setShowInstall(false);
  };

  const handleDismissInstall = () => {
    window.localStorage.setItem(DISMISS_STORAGE_KEY, String(Date.now()));
    setShowInstall(false);
  };

  const handleApplyUpdate = () => {
    if (!updateRegistration) {
      window.location.reload();
      return;
    }
    const waiting = updateRegistration.waiting;
    if (waiting) {
      waiting.postMessage({ type: "SKIP_WAITING" });
    }
    setUpdateRegistration(null);
    window.location.reload();
  };

  if (!showInstall && !updateRegistration) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 16,
        display: "flex",
        justifyContent: "center",
        zIndex: 9999,
        padding: "0 16px",
        pointerEvents: "none",
      }}
    >
      {showInstall && (
        <div
          role="dialog"
          aria-label="Install LogistiQ"
          style={{
            pointerEvents: "auto",
            background: "#0f172a",
            color: "#f8fafc",
            borderRadius: 12,
            padding: "14px 16px",
            boxShadow: "0 12px 32px rgba(15, 23, 42, 0.28)",
            display: "flex",
            alignItems: "center",
            gap: 12,
            maxWidth: 480,
            width: "100%",
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>
              Install LogistiQ
            </div>
            <div style={{ fontSize: 12, opacity: 0.75, lineHeight: 1.45 }}>
              Add to your home screen for faster access in the warehouse.
            </div>
          </div>
          <button
            type="button"
            onClick={handleDismissInstall}
            style={{
              background: "transparent",
              border: "1px solid rgba(248,250,252,0.25)",
              color: "#f8fafc",
              padding: "6px 12px",
              borderRadius: 8,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Not now
          </button>
          <button
            type="button"
            onClick={handleInstall}
            style={{
              background: "#6366f1",
              border: "none",
              color: "#fff",
              padding: "6px 14px",
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Install
          </button>
        </div>
      )}

      {updateRegistration && (
        <div
          role="dialog"
          aria-label="Update available"
          style={{
            pointerEvents: "auto",
            background: "#6366f1",
            color: "#ffffff",
            borderRadius: 12,
            padding: "12px 16px",
            boxShadow: "0 12px 32px rgba(99, 102, 241, 0.35)",
            display: "flex",
            alignItems: "center",
            gap: 12,
            maxWidth: 480,
            width: "100%",
            marginLeft: showInstall ? 12 : 0,
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>
              Update available
            </div>
            <div style={{ fontSize: 12, opacity: 0.85 }}>
              A new version of LogistiQ is ready.
            </div>
          </div>
          <button
            type="button"
            onClick={handleApplyUpdate}
            style={{
              background: "#ffffff",
              border: "none",
              color: "#4f46e5",
              padding: "6px 14px",
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      )}
    </div>
  );
};

export default PwaPrompts;
